import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { StyledContentBox } from "./ContextBox.styles";
import { ContentBoxProps } from "./ContextBox.types";

const ContextBox: React.FC<ContentBoxProps> = ({
	className,
	children,
	...props
}) => {
	const block = new BemIt("ContextBox");

	return (
		<StyledContentBox className={addClass(className).after(block)} {...props}>
			{children}
		</StyledContentBox>
	);
};

export default ContextBox;
